/*global eclipseApp, $, _, angular*/
(function () {

  'use strict';

  angular
    .module('eclipseApp.autoRegSetPassword')
    .controller('setAutoRegPasswordExpiredCtrl', SetAutoRegPasswordExpiredCtrl);

  SetAutoRegPasswordExpiredCtrl.$inject = ['$stateParams', 'setPasswordService', 'timerService'];

  function SetAutoRegPasswordExpiredCtrl($stateParams, setPasswordService, timerService) {
    var ctrl = this;

    init();

    function init() {
      timerService.stopTimer();
      ctrl.gotoContactPage = setPasswordService.gotoContactPage;
      ctrl.getPhoneNumber = setPasswordService.getPhoneNumber;

      ctrl.resendStatus = null;
    }

    ctrl.resendSms = function () {
      ctrl.resendStatus = 'in-progress';
      setPasswordService.resendSms()
        .then(function () {
          ctrl.resendStatus = 'success';
        })
        .catch(function () {
          ctrl.resendStatus = 'fail';
        });
    };

    ctrl.getResendBtnKey = function () {
      if (ctrl.resendStatus === 'in-progress') {
        return 'global.label.setAutoRegistrationPassword.button.resend.sending';
      } else if (ctrl.resendStatus === 'success') {
        return 'global.label.setAutoRegistrationPassword.button.resend.sent';
      } else if (ctrl.resendStatus === 'fail') {
        return 'global.label.setAutoRegistrationPassword.button.resend.failed';
      } else {
        return 'global.label.setAutoRegistrationPassword.button.resend.resendNow';
      }
    };

    ctrl.getResendBtnClass = function (){
      if (ctrl.resendStatus === 'in-progress') {
        return 'updating-btn';
      } else if (ctrl.resendStatus === 'success') {
        return 'updated-btn';
      } else if (ctrl.resendStatus === 'fail') {
        return 'failed-btn';
      }
    };
  }
})();
